// extracted by mini-css-extract-plugin
module.exports = {"select__cameras":"VidooNodeForTrigger_select__cameras__3EJ8m","description":"VidooNodeForTrigger_description__2r1eN"};